<template>
  <div class="auth step-box">
    <form :action="authUrl" class="auth-form" method="post">
      <button @click.prevent="skip()" class="pz-close-btn">
        <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
      </button>

      <div class="auth-form__header">Авторизация</div>
      <div class="input-wrapper login-method">
        <label class="signup-radio signup-phone">
          <input
            type="radio"
            id="rbPhone"
            name="authByPhone"
            :value="AUTH_METHOD_PHONE"
            v-model="authMethod"
            v-on:change="onAuthMethodChange(AUTH_METHOD_PHONE, $event)"
            v-on:keydown.enter.prevent="submitAuth"
          />
          <label for="rbPhone">Номер телефона</label>
        </label>
        <label class="signup-radio signup-email">
          <input
            type="radio"
            id="rbLogin"
            name="authByEmail"
            :value="AUTH_METHOD_EMAIL"
            v-model="authMethod"
            v-on:change="onAuthMethodChange(AUTH_METHOD_EMAIL, $event)"
            v-on:keydown.enter.prevent="submitAuth"
          />
          <label for="rbLogin">Логин / e-mail</label>
        </label>
      </div>

      <div class="input-wrapper" v-if="this.authMethod == this.AUTH_METHOD_PHONE">
        <input
          :class="{ hasError: this.loginError }"
          :value="login"
          @input="updateLogin"
          name="AuthForm[phone]"
          placeholder="Телефон в формате +7 (123) 456-78-90"
          type="text"
          v-mask="setting.currency === '₽' ? '+7 (###) ###-##-##' : '+375 (##) ###-##-##'"
          v-on:keydown.enter.prevent="submitAuth"
        />
        <div v-if="this.loginError">
          <p class="input-error" v-html="loginError"></p>
        </div>
      </div>
      <div class="input-wrapper" v-if="this.authMethod == this.AUTH_METHOD_EMAIL">
        <input
          :class="{ hasError: this.loginError }"
          :value="login"
          @input="updateLogin"
          name="AuthForm[email]"
          placeholder="Логин"
          type="text"
          v-on:keydown.enter.prevent="submitAuth"
        />
        <small class="input-error" v-if="this.loginError">{{ this.loginError }}</small>
      </div>

      <div class="input-wrapper">
        <input
          :class="{ hasError: this.passwordError }"
          :value="password"
          @input="updatePassword"
          name="AuthForm[password]"
          placeholder="Пароль"
          type="password"
          v-on:keydown.enter.prevent="submitAuth"
        />
        <small class="input-error" v-if="this.passwordError">{{ this.passwordError }}</small>
      </div>
      <div class="input-wrapper" v-if="this.authError">
        <p
          :key="error"
          class="input-error default-size"
          v-for="error in this.authError"
        >Неверно указан номер телефона / логин или пароль</p>
      </div>
      <div class="auth-form__footer">
        <button
          @click.prevent="showRegistrationForm"
          class="basket-btn basket-btn_small"
        >Зарегистрироваться</button>
        <input
          @click.prevent="submitAuth"
          class="basket-btn basket-btn_small"
          type="submit"
          value="Войти"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { setting } from '@/setting';
import axios from 'axios';
import { mask } from 'vue-the-mask';
import { fetchData } from '../actions/identity';
import { types } from '@/types';
import { eventBus } from '@/main.js';
import { mapState } from 'vuex';

export default {
  name: 'Login',
  directives: { mask },

  data() {
    const authPhone = 'phone';
    const authEmail = 'email';
    return {
      AUTH_METHOD_PHONE: authPhone,
      AUTH_METHOD_EMAIL: authEmail,
      authMethod: authEmail,
      authUrl: '',
      authHost: '',
      login: '',
      password: '',
      loginError: '',
      passwordError: '',
      authError: '',
    };
  },

  computed: {
    ...mapState(['setting', 'domain'])
  },

  created() {
    this.authUrl = setting.authHost + '/auth/async';

    eventBus.$on('signIn', (sender, login, password, onSuccess, onError) => {
      this.signIn(sender, login, password, onSuccess, onError);
    });
  },

  methods: {
    onAuthMethodChange(method /*, e*/) {
      this.authMethod = method;
      this.login = '';
    },

    updateLogin(e) {
      this.login = e.target.value;
      this.validateLogin();
    },

    validateLogin() {
      if (!this.login) {
        this.loginError = 'Необходимо заполнить Логин';
        return false;
      }

      this.loginError = false;
      return true;
    },

    updatePassword(e) {
      // this.updateProperty("user", "name", e.target.value);
      this.password = e.target.value;
      this.validatePassword();
    },

    validatePassword() {
      if (!this.password) {
        this.passwordError = 'Необходимо заполнить пароль';

        return false;
      }

      this.passwordError = false;
      return true;
    },

    showRegistrationForm() {
      this.skip();
      this.$modal.show('registration-form');
    },

    submitAuth(e) {
      this.validateLogin();
      this.validatePassword();
      if (this.passwordError && this.loginError) {
        e.preventDefault();
      } else {
        let onError = function(sender, response) {
          if (response.errors) sender.authError = response.data.errors;
          else if (response.data && response.data.errors)
            sender.authError = response.data.errors;
          else sender.authError = 'Произошла непредвиденная ошибка';
        };

        this.signIn(this, this.login, this.password, null, onError);
      }
    },

    skip() {
      this.$modal.hide('modal-card');
    },

    signIn(sender, login, password, onSuccess, onError) {
      const bodyFormData = new FormData();
      bodyFormData.set('AuthForm[username]', login);
      bodyFormData.set('AuthForm[password]', password);

      console.log('in signin', sender, login, password, onSuccess, onError)

      axios({
        method: 'post',
        url: this.authUrl,
        data: bodyFormData,
        withCredentials: true,
      })
        .then(response => {
          console.log(response, 'response from signin')
          if (response.data.success) {
            console.log(response.data.token)
            this.$cookie.set("i", response.data.token, { expires: 30, domain: '.premierzal.ru', sameSite: 'None', secure: '' })
            let token = response.data.token || this.$cookie.get('i');
            this.$store.commit(types.SET_ID_TOKEN, token);

            fetchData(token).then(user => {
              console.log(user, 'user');
              //debugger;

              this.$store.commit(types.SET_USER_DATA, user);
              let cardNumber =
                user && user.profile && user.publicId
                  ? user.publicId
                  : 'карта отсутствует';
              this.$store.dispatch('logUser', {
                changes: `Получен пользователь ${user.profile.name} <br>Email: ${user.email}. <br>Номер карты: ${cardNumber}`,
                status: 'up',
              });

              this.$store.dispatch('fetchCustomerAccounts');
              this.$modal.hide('modal-card');

              if (onSuccess) {
                onSuccess(sender, response);
              }
            });
          } else {
            if (onError) {
              onError(sender, response);
            }
          }
        })
        .catch(error => {
          //console.log(error);
          throw error;
        });
    },
  },
};
</script>

<style lang="scss">
.auth {
  &-form {
    position: relative;
    width: 35%;
    min-width: 450px;

    flex-direction: column;

    &__header {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 20px;
      text-align: center;
      color: #ffffff;
    }

    &__footer {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
    }
  }

  &.step-box {
    border: none;

    .input-error {
      color: white !important;
      margin: 10px 0;
      font-size: 14px !important;

      a {
        color: white;
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}

.pz-close-btn {
  background: none;
  border: 1.55px solid white;
  position: absolute;
  width: 42px;
  height: 42px;
  display: block;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -20px;
  right: -35px;
  transform: scale(.75);
  border: none;

  &:hover {
    cursor: pointer;
  }


  svg {
    width: 18px;
    height: 18px;
    fill: white;
  }
}

.pz-button-registration {
  background: none;
  border: none;
  color: white;
  margin: 10px 0;
  transition: all .3s ease;
}

.pz-button-registration:hover {
  opacity: .75;
}

.basket-btn {
  &_small {
    height: 45px;
    border: none;
    text-transform: none;
    border-radius: 8px;

    &:focus {
      outline: none;
    }
  }

  /*
  &_close {
    color: black;
    background: white;
  }
  */
}

.basket-btn_alt_close {
  position: absolute;
  top: 15px !important;
  right: 15px !important;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  background: transparent;
  border: 1px solid #ccc;
  transform: rotate(45deg);
}

.basket-btn_alt_close::before,
.basket-btn_alt_close::after {
  position: absolute;
  left: 22px;
  content: ' ';
  height: 24px;
  width: 2px;
  background-color: #ccc;
  top: 10px;
}

.basket-btn_alt_close::before {
  transform: rotate(45deg);
}

.basket-btn_alt_close:hover {
  opacity: 1;
}

.signup-radio {
  &.signup-email,
  &.signup-phone {
    width: 50%;
    display: inline-block;
    margin: 0 0 10px 0;
  }
}

@media only screen and (max-width: 480px) {
  .auth {
    width: calc(100% - 30px);
    &-form {
      width: auto !important;
      min-width: auto !important;
    }

    .login-method {
      display: flex !important;
      flex-direction: column !important;
      width: 100% !important;

      label {
        width: 100% !important;
      }
    }
  }

  .auth-form__footer {
    flex-direction: column !important;
    margin-top: 0 !important;

    .basket-btn_close {
      margin-bottom: 15px !important;
    }
  }
}
</style>
